document.addEventListener( 'DOMContentLoaded', function () {
	const toggleButton = document.getElementById( 'filter-menu-toggle' );
	const menu = document.getElementById( 'filter-menu' );

	if ( ! toggleButton || ! menu ) {
		return;
	}
	const baseUrl = toggleButton.getAttribute( 'data-base-url' );
	const closeIcon = toggleButton.querySelector( '.close-icon' );

	// Toggle navigation menu display
	toggleButton.addEventListener( 'click', function ( event ) {
		const isExpanded =
			toggleButton.getAttribute( 'aria-expanded' ) === 'true';
		toggleButton.setAttribute( 'aria-expanded', ! isExpanded );
		menu.setAttribute( 'aria-hidden', isExpanded );
		if ( ! isExpanded ) {
			menu.style.display = 'block';
		} else {
			menu.style.display = 'none';
			//resetButton();
		}
	} );

	// Handle menu item selection
	menu.querySelectorAll( 'a' ).forEach( ( link ) => {
		link.addEventListener( 'click', function ( event ) {
			toggleButton.textContent = this.textContent;
			closeIcon.style.display = 'inline'; // Show the close icon
			toggleButton.appendChild( closeIcon ); // Ensure icon is inside button for proper layout
			history.pushState( {}, '', this.href ); // Change URL (assuming pushState is okay to use)
		} );
	} );

	// Clear selection and reset to base URL
	closeIcon.addEventListener( 'click', function ( event ) {
		event.stopPropagation(); // Prevent the menu toggle from firing
		resetButton();
		history.pushState( {}, '', baseUrl );
	} );

	function resetButton() {
		toggleButton.textContent = 'All Work';
		closeIcon.style.display = 'none'; // Hide the close icon
	}
} );
